// Mirror Ticketing::Constants::TicketTypes::ATTACHMENT_MAX_BYTES
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024
